export const parseTopMenuItems = data => {
  return data.map(i => ({
    ...i,
    label: i.group?.toLowerCase()?.capitalize()
  }));
};